const ChatLogo = ({ className = "h-10 w-10" }: { className?: string }) => {
  return (
    <div className={`${className} relative`}>
      <svg
        viewBox="0 0 80 80"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Gradient definitions */}
        <defs>
          <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ff8a7a" />
            <stop offset="50%" stopColor="#fe6f5c" />
            <stop offset="100%" stopColor="#e55d4b" />
          </linearGradient>
          <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0d3560" />
            <stop offset="100%" stopColor="#092445" />
          </linearGradient>
        </defs>
        
        {/* Background circle */}
        <circle 
          cx="40" 
          cy="40" 
          r="38" 
          fill="url(#blueGradient)"
          stroke="#fe6f5c"
          strokeWidth="2"
        />
        
        {/* Compass rose design */}
        <g transform="translate(40,40)">
          {/* Main compass points */}
          <path
            d="M 0,-25 L 4,-8 L 0,-4 L -4,-8 Z"
            fill="url(#goldGradient)"
            transform="rotate(0)"
          />
          <path
            d="M 0,-25 L 4,-8 L 0,-4 L -4,-8 Z"
            fill="#fe6f5c"
            transform="rotate(90)"
          />
          <path
            d="M 0,-25 L 4,-8 L 0,-4 L -4,-8 Z"
            fill="url(#goldGradient)"
            transform="rotate(180)"
          />
          <path
            d="M 0,-25 L 4,-8 L 0,-4 L -4,-8 Z"
            fill="#fe6f5c"
            transform="rotate(270)"
          />
          
          {/* Secondary compass points */}
          <path
            d="M 0,-18 L 2,-6 L 0,-4 L -2,-6 Z"
            fill="#e5e7eb"
            transform="rotate(45)"
          />
          <path
            d="M 0,-18 L 2,-6 L 0,-4 L -2,-6 Z"
            fill="#e5e7eb"
            transform="rotate(135)"
          />
          <path
            d="M 0,-18 L 2,-6 L 0,-4 L -2,-6 Z"
            fill="#e5e7eb"
            transform="rotate(225)"
          />
          <path
            d="M 0,-18 L 2,-6 L 0,-4 L -2,-6 Z"
            fill="#e5e7eb"
            transform="rotate(315)"
          />
          
          {/* Center circle */}
          <circle cx="0" cy="0" r="6" fill="url(#goldGradient)" />
          <circle cx="0" cy="0" r="3" fill="#092445" />
          
          {/* Luxury diamond accent */}
          <path
            d="M 0,-2 L 2,0 L 0,2 L -2,0 Z"
            fill="#fe6f5c"
          />
        </g>
        
        {/* Subtle travel elements */}
        <g opacity="0.3">
          <circle cx="25" cy="25" r="1.5" fill="#fe6f5c" />
          <circle cx="55" cy="25" r="1" fill="#fe6f5c" />
          <circle cx="25" cy="55" r="1" fill="#fe6f5c" />
          <circle cx="55" cy="55" r="1.5" fill="#fe6f5c" />
        </g>
      </svg>
    </div>
  );
};

export default ChatLogo;